import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import RightSideBar from '../RightSideBar/RightSideBar';
import * as logger from '../../../logger';
import {
    CardContent,
    CardHeader,
    Card,
    Grid,
    ListItem,
    List,
    InputAdornment,
    MenuItem,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    makeStyles
} from '@material-ui/core';
import { numberFormat, numberWithCommas, replaceCommas, findArrayObjectIndex } from "../../../utils/utils";
import { addPaymentSideBarCss } from "./SupplierCssComponent";
import {
    TextField,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete,
    Switches,
    Checkboxes
} from 'mui-rff';
import { Form } from 'react-final-form';
import AmountInput from '../Inputs/AmountInput';
import TextInputState from '../Inputs/TextInputState';
import {
    PAYMENT_METHODS_LIST
} from "../../../store/constants";
import DateFnsUtils from '@date-io/date-fns';
import { getTripSuggestionSupplier } from "../../../store/actions/userActionCreators";
import { addVendorPayment } from "../../../store/actions/tripActionCreator";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { useHistory, useLocation } from 'react-router-dom';
import { Functions } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import { trackDwebEvent } from '../../analytics';


const AddPaymentSingleSupplier = ({ open, onClose, onConfirm, supplierNameValue, user, dispatchGetTripSuggestionSupplier, dispatchAddVendorPayment }) => {

    let submit, tripSubmit, tripEditSubmit;

    let locationInfo = useLocation();
    let path = locationInfo && locationInfo.pathname ? locationInfo.pathname.split("/") : [];
    let vendorIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";

    const [dialogOpen, setDialogOpen] = useState(open);
    const [sideBarTitle, setSideBarTitle] = useState("Add Supplier Payment");
    const [buttonText, setButtonText] = useState("Choose Trips");

    const [amountValue, setAmountValue] = useState("");
    const [paymentMethodValue, setPaymentMethodValue] = useState("");
    const [refNumberValue, setRefNumberValue] = useState("");
    const [paymentDateValue, setPaymentDateValue] = useState("");
    const [notesValue, setNotesValue] = useState("");

    const [checkedTrips, setCheckedTrips] = useState([]);
    const [trips, setTrips] = React.useState([]);
    const [tripAmountEditOpen, setTripAmountEditOpen] = React.useState(false);
    const [selectedForEdit, setSelectedForEdit] = React.useState(null);
    const [selectedAmount, setSelectedAmount] = React.useState(0);
    const [tripKey, setTripKey] = React.useState(null);
    const [fullyAllocted, setFullyAllocted] = useState(false);
    const [allocatedText, setAllocatedText] = useState("");
    const [dialogConfirmDisabled, setDialogConfirmDisabled] = useState(false);
    const [designCheck, setDesignCheck] = useState(false);
    const [tripsError, setTripsError] = useState(false);
    const [remainingAmount, setRemainingAmount] = useState(0);

    const classes = addPaymentSideBarCss();
    // const checkClasses = styles();


    useEffect(() => {

        if (open) {

            trackDwebEvent('Dweb Supplier Payment Initiated', {
                vendor_id: vendorIdValue,
                vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                // vendor_contact_number: ,
                vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0
            })

        }

    }, [open]);

    useEffect(() => {

        setTimeout(() => {
            if (checkedTrips && checkedTrips.length > 0) {

                for (var i = 0; i < checkedTrips.length; i++) {

                    if (trips.includes(checkedTrips[i].tripId)) {

                        if (Number(checkedTrips[i].attributionAmount) == Number(checkedTrips[i].tripBalance)) {
                            if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i]) {
                                document.getElementsByClassName('form-group-checkbox')[0].children[i].style.border = 'solid 1px #0033cc';
                            }
                            if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i] && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked') && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked')[0]) {
                                document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked')[0].style = 'color: #0033cc !important'
                            }
                        } else
                            if (Number(checkedTrips[i].attributionAmount) < Number(checkedTrips[i].tripBalance)) {
                                if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i]) {
                                    document.getElementsByClassName('form-group-checkbox')[0].children[i].style.border = 'solid 1px #e8843c';
                                }
                                if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i] && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked') && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked')[0]) {
                                    document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked')[0].style = 'color: #e8843c !important'
                                }
                            }
                    } else {
                        if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i]) {
                            document.getElementsByClassName('form-group-checkbox')[0].children[i].style = 'border: none !important';
                        }
                        if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i] && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked') && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('MuiIconButton-colorSecondary')[0]) {
                            document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('MuiIconButton-colorSecondary')[0].removeAttribute("style");
                        }
                    }
                }

            }
        }, 90)


    }, [checkedTrips, trips, designCheck])

    const initialValues = {
        amount: amountValue ? numberWithCommas(amountValue) : "",
        paymentMethod: paymentMethodValue ? paymentMethodValue : "Cash",
        refNumber: refNumberValue ? refNumberValue : "",
        paymentDate: paymentDateValue ? paymentDateValue : new Date(),
        notes: notesValue ? notesValue : ""
    }

    const initialTripValues = {
        trips: trips,
    }

    let initialTripAmountValues = {
        amount: selectedAmount ? selectedAmount : ""
    }

    const handleCancel = () => {
        setDialogOpen(false);
        onClose();
        if (sideBarTitle == "Add Supplier Payment") {
            trackDwebEvent('Dweb Supplier Payment Form Cancelled', {
                vendor_id: vendorIdValue,
                vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                // vendor_contact_number: ,
                vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                payment_amount: amountValue ? amountValue : "",
                payment_method: paymentMethodValue ? paymentMethodValue : "Cash",
                payment_date: paymentDateValue ? paymentDateValue : new Date()
            });
        } else if (sideBarTitle == "Choose Trips") {
            trackDwebEvent('Dweb Supplier Payment Choose Trips Cancelled', {
                vendor_id: vendorIdValue,
                vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                // vendor_contact_number: ,
                vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                payment_amount: amountValue ? amountValue : "",
                payment_method: paymentMethodValue ? paymentMethodValue : "Cash",
                payment_date: paymentDateValue ? paymentDateValue : new Date(),
                count_of_trips: trips && trips.length ? trips.length : 0,
                // payment_id: 
            })
        }
    }

    const handleBackClick = () => {
        setSideBarTitle("Add Supplier Payment");
        setButtonText("Choose Trips");
    }

    const getFormFields = (values) => {
        let paymentMode = values.paymentMethod;
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.formTitle}>Payment Amount</div>
                        <AmountInput
                            placeholder="Enter Amount"
                            name="amount"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            onChange={(e) => {
                                setAmountValue(e.target.value);
                            }}
                            InputProps={{
                                endAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
                            }}
                            required={true}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.mtV3} >
                        <div className={classes.formTitle}>Payment Method</div>
                        <Select
                            name="paymentMethod"
                            variant="outlined"
                            placeholder={'Select Payment Method'}
                            onChange={(e) => { setPaymentMethodValue(e.target.value) }}
                            formControlProps={{ margin: 'none', size: "small" }}
                            required={true}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV2 }}
                        >
                            {PAYMENT_METHODS_LIST && PAYMENT_METHODS_LIST.map((type) => {
                                return (<MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>);
                            })}
                        </Select>
                    </div>
                ),
            },
            {
                size: 12,
                visible: ['Cheque', 'UPI', 'Bank Transfer'].includes(paymentMode),
                field: (
                    <div className={classes.mtV3}>
                        <div className={classes.formTitle}>{(paymentMode === 'Cheque' ? 'Cheque' : 'Reference') + " Number"}</div>
                        <TextInputState
                            placeholder={"Enter the " + (paymentMode === 'Cheque' ? 'Cheque' : 'Reference') + " Number"}
                            name="refNumber"
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setRefNumberValue(e.target.value) }}
                            margin="normal"
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.mtV3}>
                        <div className={classes.formTitle}>Payment Date</div>
                        <DatePicker
                            disableFuture
                            name="paymentDate"
                            margin="normal"
                            variant="inline"
                            inputVariant="outlined"
                            size="small"
                            onChange={(date) => { setPaymentDateValue(date) }}
                            format="dd-MM-yyyy"
                            placeholder="Enter a Date"
                            required={true}
                            dateFunsUtils={DateFnsUtils}
                            className={classes.mtV2}
                            InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.mtV3}>
                        <div className={classes.formTitle}>Notes</div>
                        <TextInputState
                            placeholder="Enter Notes"
                            name="notes"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            multiline={true}
                            onChange={(e) => { setNotesValue(e.target.value) }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                ),
            },
        ]
    }

    const onSubmit = async values => {

        if (sideBarTitle == "Add Supplier Payment") {

            const suggestionData = {
                vendorId: vendorIdValue ? vendorIdValue : "",
                paymentAmount: values.amount ? replaceCommas(values.amount) : ""
            }

            setPaymentMethodValue(values.paymentMethod);
            setPaymentDateValue(values.paymentDate);

            dispatchGetTripSuggestionSupplier(suggestionData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Add Payment Single Supplier Dweb", "Get Suppliet trip suggestions successfull");
                        trackDwebEvent('Dweb Supplier Payment Choose Trips', {
                            vendor_id: vendorIdValue,
                            vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                            // vendor_contact_number: ,
                            vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                            payment_amount: amountValue ? amountValue : "",
                            payment_method: paymentMethodValue ? paymentMethodValue : "Cash",
                            payment_date: paymentDateValue ? paymentDateValue : new Date()
                        });
                        setSideBarTitle("Choose Trips");
                        setButtonText("Confirm");
                        if (data.response) {
                            let defaultTrips = [];
                            data.response.forEach(trip => {
                                if (trip && trip.attributionAmount && Number(trip.attributionAmount) != 0) {
                                    defaultTrips.push(trip.tripId)
                                }
                            });
                            setTrips(defaultTrips);
                            setCheckedTrips(data.response);
                            setDesignCheck(!designCheck);
                        }
                    }
                },
                (data) => {
                    trackDwebEvent('Dweb Supplier Payment Form Failed', {
                        failure_reason: data && data.status && data.status.message ? data.status.message : "",
                        vendor_id: vendorIdValue,
                        vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                        // vendor_contact_number: ,
                        vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                        payment_amount: amountValue ? amountValue : "",
                        payment_method: paymentMethodValue ? paymentMethodValue : "Cash",
                        payment_date: paymentDateValue ? paymentDateValue : new Date()
                    })
                    logger.log("Add Payment Single Supplier Dweb", "Get Suppliet trip suggestions failed");
                }
            );

        }

    }

    const validate = values => {

        const errors = {};

        if (values && !values.amount) {
            errors.amount = "Please enter amount";
        }
        if (values && values.amount && user && user.singleVendorBalance && Number(replaceCommas(user.singleVendorBalance)) < Number(replaceCommas(values.amount))) {
            errors.amount = "Amount cannot be greater than" + " " + numberFormat(user && user.singleVendorBalance ? user.singleVendorBalance : 0)
        }

        return errors;

    }

    // ************************************************** Trip Forms with Checkboxes For Choose Trips. **************************************************

    const getTripFormFields = (values) => {

        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV5}>
                            <div className={classes.checkBoxLabel}>Select Trips</div>
                            <Checkboxes
                                name="trips"
                                onChange={(e) => {

                                    let values = [...trips];

                                    if (values.includes(Number(e.target.value))) {
                                        values = values.filter(function (value, index, arr) {
                                            return value != Number(e.target.value);
                                        });
                                    } else {
                                        values.push(Number(e.target.value));

                                        let selected = [...checkedTrips];
                                        let index = findArrayObjectIndex('tripId', Number(e.target.value), selected);

                                        const tripBalance = Number(selected[index].tripBalance);

                                        if (remainingAmount <= tripBalance) {
                                            selected[index].attributionAmount = remainingAmount;
                                        } else if (remainingAmount > tripBalance) {
                                            selected[index].attributionAmount = tripBalance;
                                        }

                                        setCheckedTrips(selected);

                                    }
                                    setTrips([...new Set(values)])
                                    setDesignCheck(!designCheck);
                                }}
                                formControlProps={{
                                    margin: 'none',
                                    className: classes.checkboxInput
                                }}
                                formControlLabelProps={{
                                    className: classes.checkboxTripLabel
                                }}
                                formLabelProps={{
                                    className: classes.checkBoxLabel
                                }}
                                formGroupProps={{
                                    className: 'form-group-checkbox'
                                }}
                                classes={{ checked: classes.checkBoxChecked }}
                                data={getTripsSelection(values)}
                            />
                        </div>
                    </>
                )
            }
        ]
    }


    const getTripsSelection = (values) => {
        let trips = [];
        if (checkedTrips && Array.isArray(checkedTrips)) {
            for (const key in checkedTrips) {
                if (Object.hasOwnProperty.call(checkedTrips, key)) {
                    const tripData = checkedTrips[key];
                    tripData.value = tripData.tripId;
                    tripData.label = (
                        <div className={classes.mlV1} >
                            <Grid container wrap="nowrap" justify="space-between" >
                                <Grid container wrap="nowrap" direction="column" classes={{ container: classes.containerWidthV1 }}>
                                    <Grid item className={classes.gridRoute}>
                                        <span>{tripData && tripData.startLocation ? tripData.startLocation : ""}&nbsp;</span>
                                        <span>-</span>
                                        <span>&nbsp;{tripData && tripData.destinationLocation ? tripData.destinationLocation : ""}</span>
                                    </Grid>
                                    <Grid item className={classes.gridParam}>
                                        {tripData && tripData.params.length > 0 && tripData.params.map((paramData, index) => (
                                            <>
                                                <div>{paramData ? paramData : ""}</div>
                                                {index != tripData.params.length - 1 &&
                                                    <FiberManualRecordIcon className={classes.dotV1} />
                                                }
                                            </>
                                        ))}
                                    </Grid>
                                </Grid>
                                <Grid container wrap="nowrap" direction="column" classes={{ container: classes.containerWidth }}>
                                    {values && values.trips && !values.trips.includes(tripData.tripId) &&
                                        <Grid item className={classes.tripBalance} >
                                            {tripData && tripData.tripBalance ? numberFormat(tripData.tripBalance) : ""}
                                        </Grid>
                                    }
                                    {values && values.trips && values.trips.includes(tripData.tripId) &&
                                        <>
                                            <Grid container wrap="nowrap" alignItems="center" classes={{ container: classes.containerWidth }} >
                                                <Grid item className={classes.gridItemV1} >
                                                    <TextField
                                                        name={'attributionAmount-' + tripData.tripId}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth={false}
                                                        value={tripData.attributionAmount ? numberFormat(tripData.attributionAmount) : 0}
                                                        margin="none"
                                                        onClick={(e) => {
                                                            handleTripAmountClick(e, key)
                                                        }}
                                                        onChange={(e) => {
                                                            //handleFieldChanges(e,key)
                                                        }}
                                                        className={classes.cardInput}
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <div className={Number(tripData.attributionAmount) < Number(tripData.tripBalance) ? classes.divAlignV1 : classes.divAlign} >
                                                        <div className={classes.marginV1} >/</div>
                                                        <div>{tripData.tripBalance ? numberFormat(tripData.tripBalance) : ""}</div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <Grid item className={classes.gridItemStatus} >
                                                {Number(tripData.attributionAmount) == Number(tripData.tripBalance) &&
                                                    <div className={classes.divBox}>
                                                        Full Payment
                                                    </div>
                                                }
                                                {Number(tripData.attributionAmount) < Number(tripData.tripBalance) &&
                                                    <div className={classes.divBoxPart}>
                                                        Part Payment
                                                    </div>
                                                }
                                            </Grid>
                                        </>
                                    }

                                </Grid>
                            </Grid>
                        </div >
                    )

                    trips.push(tripData);
                }

            }
        }

        return trips;
    }

    const onTripSubmit = values => {

        const paymentDetails = {
            amount: amountValue ? replaceCommas(amountValue) : "",
            paymentMode: paymentMethodValue ? paymentMethodValue : "",
            isAdvance: false,
            paymentData: refNumberValue ? refNumberValue : "",
            vendorId: Number(vendorIdValue),
            description: notesValue ? notesValue : "",
            paymentDate: paymentDateValue ? Math.round((paymentDateValue.setHours(0, 0, 0, 0) / 1000)) : "",
            receivedByDriver: false
        }


        if (trips && trips.length > 0) {
            const tripList = []
            trips.map((tripData) => {
                const filteredData = checkedTrips.filter((tripListData) => tripListData.tripId == tripData);
                if (filteredData && filteredData[0] && filteredData[0].attributionAmount != 0) {
                    tripList.push({
                        tripId: filteredData && filteredData[0] && filteredData[0].tripId ? filteredData[0].tripId : "",
                        attributionAmount: filteredData && filteredData[0] && filteredData[0].attributionAmount ? Number(filteredData[0].attributionAmount) : ""
                    })
                }
            });
            paymentDetails.tripsAttributed = tripList;
        }

        dispatchAddVendorPayment(paymentDetails,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Add Payment Single Supplier Dweb', 'Add vendor payment Sucsessfull');
                    setDialogOpen(false);
                    onConfirm();
                    trackDwebEvent('Dweb Supplier Payment Successful', {
                        vendor_id: vendorIdValue,
                        vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                        // vendor_contact_number: ,
                        vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                        payment_amount: amountValue ? amountValue : "",
                        payment_method: paymentMethodValue ? paymentMethodValue : "Cash",
                        payment_date: paymentDateValue ? paymentDateValue : new Date(),
                        count_of_trips: paymentDetails && paymentDetails.tripsAttributed ? paymentDetails.tripsAttributed.length : 0
                    });
                }
            },
            (data) => {
                logger.log('Add Payment Single Supplier Dweb', 'Add vendor payment Failed');
                trackDwebEvent('Dweb Supplier Payment Choose Trips Failed', {
                    failure_reason: data && data.status && data.status.message ? data.status.message : "",
                    vendor_id: vendorIdValue,
                    vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                    // vendor_contact_number: ,
                    vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                    payment_amount: amountValue ? amountValue : "",
                    payment_method: paymentMethodValue ? paymentMethodValue : "Cash",
                    payment_date: paymentDateValue ? paymentDateValue : new Date(),
                    count_of_trips: paymentDetails && paymentDetails.tripsAttributed ? paymentDetails.tripsAttributed.length : 0
                });
            }
        )

    }

    const tripValidate = values => {

        let errors = [];

        if (values && values.trips && values.trips.length == 0) {
            setTripsError(true);
        } else {
            setTripsError(false);
        }

        let allocatedAmount = 0;
        let amountValueEntered = Number(replaceCommas(amountValue));

        for (var i = 0; i < values.trips.length; i++) {

            let filteredTrip = checkedTrips.filter((tripData) => tripData.tripId == (values && values.trips[i] ? values.trips[i] : ""))
            allocatedAmount += filteredTrip && filteredTrip[0] && filteredTrip[0].attributionAmount ? Number(filteredTrip[0].attributionAmount) : 0
        }

        if (allocatedAmount == amountValueEntered) {
            setAllocatedText(numberFormat(amountValueEntered));
            setRemainingAmount(0);
            setFullyAllocted(true);
        } else if (allocatedAmount < amountValueEntered) {
            setAllocatedText(numberFormat(amountValueEntered - allocatedAmount));
            setFullyAllocted(false);
            setRemainingAmount(replaceCommas(amountValueEntered - allocatedAmount));
        }

        return errors;
    }


    // ******************************************** Edit Amount Dialog Actions and Functions. ********************************************
    const handleTripAmountClick = (e, key) => {
        if (checkedTrips) {
            setTripKey(key);
            setSelectedForEdit(checkedTrips[key]);
            setSelectedAmount(checkedTrips && checkedTrips[key] && checkedTrips[key].attributionAmount ? checkedTrips[key].attributionAmount : 0)
            setTripAmountEditOpen(true);
        }
    }

    const handleEditAmountClose = () => {
        setTripKey(null);
        setSelectedForEdit(null);
        setSelectedAmount(null);
        setTripAmountEditOpen(false);
    }

    const onTripEditSubmit = values => {
        if (Object.keys(editAmountValidate(initialTripAmountValues)).length == 0) {
            let values = [...checkedTrips];
            values[tripKey].attributionAmount = replaceCommas(selectedAmount);
            setCheckedTrips(values);
            setTripKey(null);
            setSelectedForEdit(null);
            setSelectedAmount(null);
            setTripAmountEditOpen(false);
            trackDwebEvent('Dweb Supplier Payment Trip Amount Changed', {
                vendor_id: vendorIdValue,
                vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                // vendor_contact_number: ,
                vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                payment_amount: amountValue ? amountValue : "",
                payment_method: paymentMethodValue ? paymentMethodValue : "Cash",
                payment_date: paymentDateValue ? paymentDateValue : new Date(),
                trip_id: selectedForEdit && selectedForEdit.tripId ? selectedForEdit.tripId : "",
                trip_supplier_balance: selectedForEdit && selectedForEdit.tripBalance ? selectedForEdit.tripBalance : 0,
                trip_payment_amount: selectedAmount ? selectedAmount : 0,
            });
        }
    }

    const getAmountFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.divAmountContainer} >
                        <div className={classes.titleV3}>Amount</div>
                        <AmountInput
                            placeholder="Enter Amount"
                            name="amount"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            onChange={(e) => {
                                setSelectedAmount(e.target.value)
                            }}
                            InputProps={{
                                endAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
                            }}
                            className={classes.mtV4}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                ),
            }
        ]
    }

    const editAmountValidate = values => {
        const errors = {};
        let allocatedAmount = 0;

        let ignoreTripId = checkedTrips && checkedTrips[tripKey] && checkedTrips[tripKey].tripId ? checkedTrips[tripKey].tripId : "";

        for (var i = 0; i < trips.length; i++) {
            let filteredTrip = checkedTrips.filter((tripData) => {
                return tripData.tripId == (trips[i] ? trips[i] : "") && tripData.tripId != ignoreTripId
            })
            allocatedAmount += filteredTrip && filteredTrip[0] && filteredTrip[0].attributionAmount ? Number(filteredTrip[0].attributionAmount) : 0
        }


        if (values && values.amount && Number(replaceCommas(values.amount)) > (Number(replaceCommas(amountValue)) - Number(allocatedAmount ? replaceCommas(allocatedAmount) : 0))) {
            errors.amount = "Amount cannot be greater than " + numberFormat(Number(replaceCommas(amountValue)) - Number(allocatedAmount ? replaceCommas(allocatedAmount) : 0))
        }


        if (errors && errors.amount) {
            setDialogConfirmDisabled(true);
        } else {
            setDialogConfirmDisabled(false);
        }

        return errors;
    }

    return (
        <>
            {dialogOpen && <RightSideBar
                sideBarName="add-payment-single-supplier"
                rightSideBarOpen={dialogOpen}
                sideBarTitle={sideBarTitle}
                sideBarType={"paymentDetailSingleSupplier"}
                handleSubmit={event => submit(event)}
                toggleRightSideBar={handleCancel}
                chooseTripConfirm={event => tripSubmit(event)}
                backClick={handleBackClick}
                confirmText={buttonText}
                onValidate={validate(initialValues)}
                fullyAllocatedFlag={fullyAllocted}
                allocatedTextValue={allocatedText}
                tripsError={tripsError}
            >

                <Grid container alignItems="center" justify="space-between" wrap="nowrap" className={classes.gridContainer}>
                    <Grid container direction="column">
                        <Grid item className={classes.titleV1} >
                            Supplier Name
                        </Grid>
                        <Grid item className={classes.textV1} >
                            {/* {supplierNameValue ? supplierNameValue : ""} */}
                            {user && user.singleVendorPageName ? user.singleVendorPageName : ""}
                        </Grid>
                    </Grid>
                    <Grid container direction="column">
                        <Grid item className={classes.titleV2}>
                            {sideBarTitle == "Add Supplier Payment" &&
                                <>
                                    Total Balance
                                </>
                            }
                            {sideBarTitle == "Choose Trips" &&
                                <>
                                    Payment Amount
                                </>
                            }
                        </Grid>
                        <Grid item className={classes.textV2}>
                            {sideBarTitle == "Add Supplier Payment" &&
                                <>
                                    {numberFormat(user && user.singleVendorBalance ? user.singleVendorBalance : 0)}
                                </>
                            }
                            {sideBarTitle == "Choose Trips" &&
                                <>
                                    {amountValue ? numberFormat(replaceCommas(amountValue)) : numberFormat(0)}
                                </>
                            }
                        </Grid>
                    </Grid>
                </Grid>

                {sideBarTitle == "Add Supplier Payment" &&
                    <div className={classes.mtV1} >
                        <Form
                            onSubmit={onSubmit}
                            initialValues={initialValues}
                            validate={validate}
                            render={({ handleSubmit, form, submitting, pristine, values }) => {
                                submit = handleSubmit
                                return (
                                    <form onSubmit={handleSubmit} noValidate>
                                        <Grid container className={classes.paymentForm} alignItems="flex-start" spacing={0}>
                                            {getFormFields(values).map((item, idx) => item.visible ? (
                                                <Grid item xs={item.size} key={idx}>
                                                    {item.field}
                                                </Grid>
                                            ) : null)}
                                        </Grid>
                                    </form>
                                )
                            }}
                        />
                    </div>
                }

                {sideBarTitle == "Choose Trips" &&
                    <div>
                        <Form
                            onSubmit={onTripSubmit}
                            initialValues={initialTripValues}
                            validate={tripValidate}
                            render={({ handleSubmit, form, submitting, pristine, values }) => {
                                tripSubmit = handleSubmit; return (
                                    <form onSubmit={handleSubmit} noValidate>
                                        <Grid container className={classes.paymentForm} alignItems="flex-start" spacing={0}>
                                            {getTripFormFields(values).map((item, idx) => item.visible ? (
                                                <Grid item xs={item.size} key={idx}>
                                                    {item.field}
                                                </Grid>
                                            ) : null)}
                                        </Grid>
                                    </form>
                                )
                            }}
                        />
                    </div>
                }

            </RightSideBar>
            }

            {/* ******************************** Dialog to edit trip amount (trip attribution amount.) ********************************  */}
            {tripAmountEditOpen &&
                <Dialog fullWidth={true} maxWidth='xs' onClose={handleEditAmountClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="trip-amount-edit-dialog-title" open={tripAmountEditOpen} className={classes.dialogV1} classes={{ paperWidthXs: classes.widthV1 }} >
                    <DialogTitle id="trip-amount-edit-dialog-title" className={classes.dialogTitleV1}>
                        <div className={classes.divAlignTitle} >
                            <div className={classes.divTitle} >
                                Enter Amount
                            </div>
                            <div>
                                <IconButton onClick={handleEditAmountClose}>
                                    <CloseIcon className={classes.closeIconV1} />
                                </IconButton>
                            </div>
                        </div>
                    </DialogTitle>
                    <DialogContent dividers className={classes.dialogContentV1}>

                        <Grid container direction="column">

                            <Grid container direction="row" justify="space-between" alignItems="center" wrap="nowrap" className={classes.gridTitleDialog}>
                                <Grid item>
                                    Trip Details
                                </Grid>
                                <Grid item>
                                    Balance
                                </Grid>
                            </Grid>

                            <Grid container direction="row" justify="space-between" alignItems="center" wrap="nowrap" className={classes.gridContainerDialog}>

                                <Grid container direction="column" wrap="nowrap" classes={{ container: classes.containerWidth }}>
                                    <Grid item className={classes.gridRouteDialog}>
                                        <span>{selectedForEdit && selectedForEdit.startLocation ? selectedForEdit.startLocation : ""}&nbsp;</span>
                                        <span>-</span>
                                        <span>&nbsp;{selectedForEdit && selectedForEdit.destinationLocation ? selectedForEdit.destinationLocation : ""}</span>
                                    </Grid>
                                    <Grid item className={classes.gridParamsDialog} >
                                        {selectedForEdit && selectedForEdit.params.length > 0 && selectedForEdit.params.map((paramData, index) => (
                                            <>
                                                <div>{paramData ? paramData : ""}</div>
                                                {index != selectedForEdit.params.length - 1 &&
                                                    <FiberManualRecordIcon className={classes.dotV2} />
                                                }
                                            </>
                                        ))}
                                    </Grid>
                                </Grid>

                                <Grid item className={classes.containerWidth}>
                                    <div className={classes.textBalance}>
                                        {selectedForEdit && selectedForEdit.tripBalance ? numberFormat(selectedForEdit.tripBalance) : numberFormat(0)}
                                    </div>
                                </Grid>

                            </Grid>

                        </Grid>

                        <Form
                            onSubmit={onTripEditSubmit}
                            keepDirtyOnReinitialize
                            initialValues={initialTripAmountValues}
                            validate={editAmountValidate}
                            render={({ handleSubmit, form, submitting, pristine, values }) => {
                                tripEditSubmit = handleSubmit; return (
                                    <form onSubmit={handleSubmit} noValidate>
                                        <Grid container className={classes.paymentForm} alignItems="flex-start" spacing={0}>
                                            {getAmountFormFields(values).map((item, idx) => item.visible ? (
                                                <Grid item xs={item.size} key={idx}>
                                                    {item.field}
                                                </Grid>
                                            ) : null)}
                                        </Grid>
                                    </form>
                                )
                            }}
                        />

                    </DialogContent>
                    <DialogActions className={classes.dialogActionsV1} >
                        <Button variant="contained" className={classes.closeButton} onClick={handleEditAmountClose} >
                            Close
                        </Button>
                        <Button className={classes.saveButton} variant="contained" onClick={onTripEditSubmit} disabled={dialogConfirmDisabled} classes={{ disabled: classes.saveButtonDisabled }} >
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchGetTripSuggestionSupplier: (suggestionData, onSuccess, onError) => {
        dispatch(getTripSuggestionSupplier(suggestionData, onSuccess, onError))
    },
    dispatchAddVendorPayment: (paymentDetails, onSuccess, onError) => {
        dispatch(addVendorPayment(paymentDetails, onSuccess, onError))
    }

});

export default connect(mapStateToProps, mapDispatchToProps)(AddPaymentSingleSupplier);